import React from 'react';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';
import setupquestions from '../setupquestions';

const styles = {
    iconRed: { 
           paddingRight: '0.5em' ,
           color: 'orange'
        },
    icon: { 
        paddingRight: '0.5em' ,
        },
    link: {
        display: 'inline-flex',
        alignItems: 'center'
    },
};

const LinkToExam = ({ classes, record}) => {
    console.log(record)
    return record.day_to_exp < 7 ? <Button
        size="small"
        color= "primary" 
        component={Link}
        to={{
            pathname: '/examlogs/create',
            exam_id: record.training_id,
            exam_name: record.training_name ,
            user_id : record.user_id
        }}
        className={classes.link}
    >
        <setupquestions.icon />Exam
    </Button> :<div></div>
};

export default withStyles(styles)(LinkToExam);
